import React from "react";
function Component({ configuration }) {
    return (React.createElement("a", { className: "rt-all-stores", href: `${configuration.hostname}${configuration.translations.controls.allStores.link}` }, configuration.translations.controls.allStores.text));
}
export const dynamicComponent = {
    Component,
    checkExpectedProps: (props) => { },
};
